<template>
    <div class="whitespace-top-small">
        <aside class="hint-panel hint-panel__quick-tip">
            <i class="icon"><icon-hint /></i>
            <div class="content">
                <p>
                    Learn more about
                    <a
                        href="https://support.gifthero.com/page/managing-wish-lists#wish-list-privacy"
                        target="_blank"
                        rel="noopener"
                        title="Learn more about list privacy"
                        >list privacy</a
                    >
                    settings.
                </p>
            </div>
        </aside>
    </div>
</template>
<script setup>
import IconHint from "~/svg/icon-hint.svg";
</script>
